import React, { useState, useEffect } from 'react'
import ResponseMsg from '../general/ResponseMsg';
import Loading from '../general/Loading';
import StaffImg from '../assets/staff-img.png';
import StaffImg1 from '../assets/staff-img1.gif';

const AddStaff = () => {
  const [response, setResponse] = useState(null);
  const [staff, setStaff] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState('');
  const [showDelete, setShowDelete] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
     const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [newStaff, setNewStaff] = useState({
    name: '',
    phone: '',
    category: '',
    password: '',
    city: '',
    state: '',
  });

  // Fetch staff members on component mount
  useEffect(() => {
    const fetchStaff = async () => {
      setLoading(true);
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-staff');

        setLoading(false);
        if (response.ok) {
          const data = await response.json();
  const sortedData = data.sort((a, b) => b.id - a.id);
          setStaff(sortedData);
        } else {
          setLoading(false);
          console.error('Failed to fetch staff members');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching staff:', error);
      }
    };

    fetchStaff();
  }, []);


  const handleRemoveDialog = (staffMem) => {
    setSelectedStaff(staffMem);
    setShowDelete(true);
  }

  const handleRemove = async (staffId) => {
    setLoading(true);

    try {
      const response = await fetch(`https://api.kcmstore.in/store/delete-staff/${staffId}`, {
        method: 'DELETE',
      });

      setLoading(false);

      if (response.ok) {
        setStaff((prevStaff) => prevStaff.filter((staff) => staff.id !== staffId));
        setResponse('Sub Admin Removed successfully!');
        setTimeout(() => {
          setResponse('');
        }, 2000);
        setShowDelete(false);
      } else {
        setLoading(false);
        setResponse('Unable to Delete Sub Admin.');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error deleting sub admin:', error);
    }
  };


  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setNewStaff((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle Add Staff form submission
  const handleAddStaff = async (e) => {
    e.preventDefault();
    setLoading(true);


    try {
      const response = await fetch('https://api.kcmstore.in/store/add-staff', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newStaff),
      });

      setLoading(false);

      if (response.ok) {
        setResponse('Sub Admin added successfully!');
        setTimeout(() => {
          setResponse('');
          setNewStaff({ name: '', phone: '', category: '', password: '' });
          setShowAdd(false);
          window.location.reload();
        }, 2000);
      } else if (response.status == 400) {
        setLoading(false);
        setResponse('Staff exists with same Mobile no.');
        setTimeout(() => setResponse(''), 2000);
      }
      else {
        setLoading(false);
        setResponse('Unable to add Sub Admin.');
        setTimeout(() => setResponse(''), 2000);
      }
    } catch (error) {
      console.error('Error adding Sub Admin:', error);
    }
  };

  const filteredStaff = staff.filter(myStaff =>
    (myStaff.name?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myStaff.phone?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myStaff.address?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myStaff.city?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myStaff.state?.toLowerCase().includes(searchQuery.toLowerCase()) || '') ||
    (myStaff.pincode?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
  );
  

  
  const indianStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
    "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
    "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands",
    "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu", "Lakshadweep",
    "Delhi", "Puducherry"
];



  return (
    <>
      <section className='py-4 bg-light'>
        <div className='px-4'>
          <div className='d-flex'>
            <p className='sec-heading'>Sub Admins</p>
            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Add</span>
          </div>

          <div className='row justify-content-between'>
            <div className='d-flex bg-white rounded-4 col-lg-10 col-md-8 col-sm-7 col-12 my-2'>
              <i class="fa-solid fa-magnifying-glass text-darkblue pt-3 px-3"></i>
              <input
                type="text"
                className="form-input rounded-4 border-0"
                placeholder="Search Branch"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className='col-lg-2 col-md-4 col-sm-5 col-12 my-2 order-lg-last order-md-last order-sm-last order-first'>
              <button className='login-btn2' onClick={() => setShowAdd(true)}>Add Branch</button></div>

          </div>


          <div className='row bg-white rounded-4 px-lg-2 py-3 mt-3'>

            {filteredStaff.length > 0 ? (
              filteredStaff.map((staffMem) => (
                <div key={staffMem.id} className='col-lg-4 col-md-6 col-sm-6 col-12 my-2 px-2'>
                  <div className='staff-area d-lg-block d-md-block d-sm-block d-flex '>
                    <img src={StaffImg} className='staff-img' alt='Staff' />
                    <div className='text-lg-center text-md-center text-sm-center text-start'>
                      <p className='featured-category text-capitalize'>Branch: {staffMem.name}<br />
                        Phone: {staffMem.phone}<br />Email: {staffMem.email || 'NA'}<br />Address: {staffMem.address || ''} {staffMem.city} {staffMem.state} {staffMem.pincode}</p>
                      <button className='login-btn mt-4' onClick={() => handleRemoveDialog(staffMem)}>Remove</button></div>
                  </div>
                </div>
              ))
            ) : (
              <>
                <div className='text-center'>
                  <img src={StaffImg1} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                  <p className='fw-bold'>No Staff Added yet.</p>
                </div>
              </>
            )}


          </div>
          {/* row ends */}

        </div>
      </section>

      {showDelete && (
        <>
          <section className='delete-dialog px-3'>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4'>
              <p className='featured-category my-4'>Do you want to remove {selectedStaff.name} Branch from Sub Admin?</p>
              <button className='success-btn' onClick={() => handleRemove(selectedStaff.id)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowDelete(false)}>No</button>
            </div>
          </section>
        </>
      )}


      {showAdd && (
        <>
          <section className='delete-dialog px-3 py-5'>
            <div className='bg-white col-lg-5 col-md-8 mx-auto px-3 py-3 rounded-4'>

              <p className='sec-heading'>Add New Branch</p>


              <form class="row g-3 text-start" onSubmit={handleAddStaff}>
                <div class="col-12">
                  <label for="inputName" class="form-label fw-semibold">Name</label>
                  <input type="text" class="form-input" id="inputName" name='name' value={newStaff.name} onChange={handleInputChange} required />
                </div>
                <div class="col-md-6">
                  <label for="inputPhone" class="form-label fw-semibold">Phone</label>
                  <input type="tel" minLength={10} maxLength={10} class="form-input" id="inputPhone" name='phone' value={newStaff.phone} onChange={handleInputChange} required />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold" htmlFor="category">Category</label>
                  <select className="form-input" id="category" name='category' value={newStaff.category} onChange={handleInputChange} required>
                    <option value="" disabled selected>None</option>
                    <option value="Sub Admin">Sub Admin</option>
                  </select>
                </div>

                <div class="col-12">
                  <label for="inputPassword4" class="form-label fw-semibold">Password</label>
                  <input type="password" class="form-input" minLength={6} id="inputPassword4" name='password' value={newStaff.password} onChange={handleInputChange} required />
                </div>

                <div class="col-md-6">
                  <label for="inputCity" class="form-label fw-semibold">City</label>
                  <input type="text" class="form-input" id="inputCity" name='city' value={newStaff.city} onChange={handleInputChange} required />
                </div>

                <div class="col-md-6">
                  <label for="inputState" class="form-label fw-semibold">State</label>
                  <select
                                                    id="state"
                                                    className="form-input"
                                                    value={newStaff.state}
                                                    name='state'
                                                    onChange={handleInputChange}
                                                    required
                                                >
                                                    <option value="" disabled>Select State</option>
                                                    {indianStates.map((state, index) => (
                                                        <option key={index} value={state}>
                                                            {state}
                                                        </option>
                                                    ))}
                                                </select>
                  {/* <input type="text" class="form-input" id="inputState" name='state' value={newStaff.state} onChange={handleInputChange} required /> */}
                </div>

                <div class="col-12 my-3">
                  <button className='danger-btn' onClick={() => setShowAdd(false)}>Cancel</button>&nbsp;&nbsp;
                  <button type="submit" class="success-btn">Add</button>
                </div>
              </form>

            </div>
          </section>
        </>
      )}

      {response && <ResponseMsg message={response} />}
      {loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default AddStaff
